import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

//import { RedirectService } from './core/services/auth-guard/redirect.service';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { OtpComponent } from './auth/otp/otp.component';
import { RedirectService } from './core/services/auth-guard/redirect.service';
import { SessionExpiredComponent } from './core/session-expired/session-expired.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
// import { OtpComponent } from './auth/otp/otp.component';
// import { SessionExpiredComponent } from './core/session-expired/session-expired.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [RedirectService]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [RedirectService]
  },
  {
    path: 'register',
    component: RegisterComponent,
    //canActivate: [RedirectService]
  },
  {
    path: 'otp',
    component: OtpComponent,
    //canActivate: [RedirectService]
  },
  {
    path: 'expired',
    component: SessionExpiredComponent,
    // canActivate: [RedirectService]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    // canActivate: [RedirectService]
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    // canActivate: [RedirectService]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    // pathMatch: 'prefix',
    children: [{
      path: '',
      loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
    }]
  },
  {
    path: '**',
    redirectTo: '/expired',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
